import PropTypes from 'prop-types';
import LazyLoad from '../LazyLoad';
import Package from './index';
import NewPackage from './package-new';

export default function PackageLazy({isNewDesign, isShoppingDesign = false, variant = '', limitedItems, ...props}) {
  return (
    <LazyLoad>
      { isNewDesign
        ? <NewPackage isShoppingDesign={isShoppingDesign} limitedItems={limitedItems} variant={variant} />
        : <Package {...props} />
      }
    </LazyLoad>
  );
}

PackageLazy.propTypes = {
  isNewDesign: PropTypes.bool,
  isShoppingDesign: PropTypes.bool,
  limitedItems: PropTypes.number,
  variant: PropTypes.string,
};
